  
(function ($) {
  //////////////////////////////////////////////////////////////////////////////
  //Smooth Scrolling
  //////////////////////////////////////////////////////////////////////////////
  //

  // Select all links with hashes
  $('a[href*="#"]')
    .not('[href="#"]')
    .not('[href="#0"]')
    .on('click', function (event) {
      // On-page links
      if (
        location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') &&
        location.hostname == this.hostname
      ) {
        // Figure out element to scroll to
        var target = $(this.hash);
        target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');


        // Does a scroll target exist?
        if (target.length) {
          // Only prevent default if animation is actually gonna happen
          event.preventDefault();
          if ($(this).parents('.scrolling-target').length == 1) {
            $('html, body').animate({
              scrollTop: target.position().top - ($(this).parents('.scrolling-target').height())
            }, 550);

          } else {
            $('html, body').animate({
              scrollTop: target.position().top
            }, 550);

          }
        }
      }
    });

  })(jQuery); // or even jQuery.noConflict()